import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const faqs = [
  {
    q: "AI生成のクオリティは大丈夫ですか？",
    a: "導入企業で外注制作よりCPAが1/3に改善した事例があります。広告は「質」より「検証回数」が成果に直結します。Taskyは高品質なバナーを大量に生成することで、勝ちパターンの発見を加速します。",
  },
  {
    q: "どの業界で使えますか？",
    a: "全業界に対応しています。アパレル、コスメ、飲料、自動車、不動産、EC全般、金融・保険、教育・スクール等で実績があります。100万件以上の配信データから業界別の勝ちパターンを学習済みです。",
  },
  {
    q: "既存のワークフローとどう組み合わせますか？",
    a: "既存の制作フローを置き換えるのではなく、検証用クリエイティブの量産に使うケースが多いです。Taskyで勝ちパターンを高速で発見し、それをベースに本制作に回す運用が最も効果的です。",
  },
  {
    q: "チームで使えますか？",
    a: "Teamプラン以上はユーザー数無制限です。勝ちバナーの社内共有、制作物の一元管理が可能です。",
  },
  {
    q: "動画も作れますか？",
    a: "対応済みです。静止画バナー、カルーセル広告、漫画広告、動画バナーに対応。画像素材・動画素材の生成も可能です。",
  },
  {
    q: "どんなAIを使っていますか？",
    a: "OpenAI、Claude、Gemini、BytePlusのハイエンドモデルを標準搭載。用途ごとに最適なモデルを自動選択する設計です。単一モデルに依存しないことで品質・速度・コストのバランスを最適化しています。",
  },
  {
    q: "他のAI広告ツールと何が違いますか？",
    a: 'Taskyは「URLを入れるだけ」で訴求設計からバナー生成まで全自動。他社は生成はできますが、「何を訴求すべきか」はユーザーが考える必要があります。日本市場に最適化された100万件以上の学習データと、業界別の勝ちパターンを搭載しています。',
  },
  {
    q: "セキュリティは大丈夫ですか？",
    a: "入力された商品情報・生成データは暗号化して保管。外部学習への二次利用は行いません。",
  },
];

function FAQItem({ faq }: { faq: { q: string; a: string } }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-[rgba(29,25,38,0.08)]">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-start justify-between gap-4 py-6 text-left"
      >
        <span className="text-[18px] font-medium">{faq.q}</span>
        <span className="flex-shrink-0 mt-1 w-5 h-5 flex items-center justify-center">
          <svg
            className={`w-4 h-4 text-[#1d1926]/40 transition-transform ${
              open ? "rotate-45" : ""
            }`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4v16m8-8H4"
            />
          </svg>
        </span>
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
            className="overflow-hidden"
          >
            <p className="pb-6 text-[16px] text-[#1d1926]/60 leading-relaxed max-w-[720px]">
              {faq.a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

const FAQSection: React.FC = () => {
  return (
    <section id="faq" className="py-24 md:py-40">
      <div className="max-w-[760px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-[36px] md:text-[52px] font-extrabold tracking-[-0.03em]">
            よくある質問
          </h2>
        </motion.div>

        <div>
          {faqs.map((faq) => (
            <FAQItem key={faq.q} faq={faq} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
